import { render } from "./markdownWin.vue?vue&type=template&id=2bbb4756&scoped=true"
import script from "./markdownWin.vue?vue&type=script&lang=js"
export * from "./markdownWin.vue?vue&type=script&lang=js"

import "./markdownWin.vue?vue&type=style&index=0&id=2bbb4756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbb4756"]])

export default __exports__